/**
 * Replies stopped in this tab (MHS-863). One whose worker died stays listed as running until the backend ends it
 * (once its chat hold lapses, a few minutes; MHS-862): remembered, it isn't picked up again after a reload or a
 * visit to another page, and a send it still refuses is explained. Kept 30 minutes, past that window; without
 * storage, not kept.
 */

const KEY = "anthm.stoppedReplies";
const KEEP_MS = 30 * 60_000;

/** Operation id → when it was stopped (ms since the epoch). */
type Stopped = Record<string, number>;

function read(): Stopped {
  try {
    const stored: unknown = JSON.parse(sessionStorage.getItem(KEY) ?? "{}");
    return stored && typeof stored === "object" ? (stored as Stopped) : {};
  } catch {
    return {};
  }
}

export function rememberStopped(opId: string, now = Date.now()): void {
  const kept = Object.entries(read()).filter(([, at]) => now - at < KEEP_MS);
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ...Object.fromEntries(kept), [opId]: now }));
  } catch {
    // Storage unavailable (private mode etc.): the reply may show as being written again after a reload.
  }
}

export function stoppedHere(opId: string | undefined, now = Date.now()): boolean {
  const at = opId ? read()[opId] : undefined;
  return at !== undefined && now - at < KEEP_MS;
}
